<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      :show-save-button="$permission.canEdit()"
      unit="板块设置"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="95px"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      :get-data-func="api.info"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="板块名称" prop="SectionName">
              <el-input
                v-model="data.SectionName"
                placeholder="请填写板块名称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="链接类型" prop="SectionType">
              <el-select
                v-model="data.SectionType"
                placeholder="请选择链接类型"
                clearable
              >
                <el-option label="静态展示" :value="0"></el-option>
                <el-option label="商品分类" :value="1"></el-option>
                <el-option label="指定商品" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="loginInfo.UserType == 0">
          <el-col :span="24">
            <el-form-item label="所属商家" prop="StoreId">
              <business-select
                v-model="data.StoreId"
                ref="businessSelect"
              ></business-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="data.SectionType == 1">
            <el-form-item label="商品分类" prop="GoodsTypeId">
              <tree-select
                ref="treeSelect"
                :props="props"
                :options="TypePlatforms"
                :value="data.GoodsTypeId"
                :clearable="false"
                :accordion="true"
                :parentSelect="true"
                placeholder="请选择"
                @node-select="onTreeSelect($event)"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="data.SectionType == 2">
            <el-form-item label="商品名称" prop="GoodsName">
              <el-input
                v-model="data.GoodsName"
                placeholder="点击选择"
                readonly
                suffix-icon="el-icon-search"
                @focus="onGoodsDialog"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="图片" prop="PhotoAddress">
              <single-pic-upload
                v-model="data.PhotoAddress"
                type="PhotoAddress"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="false">
          <el-col :span="24">
            <el-form-item label="链接地址" prop="LinkAddress">
              <el-input
                v-model="data.LinkAddress"
                placeholder="请填写链接地址"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="序号" prop="OrderId">
              <el-input-number v-model="data.OrderId" :min="0" />
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <goods-dialog
      ref="goodsDialog"
      in-dialog
      selectable
      :multiple="false"
      @select="setGoods"
    />
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";
import businessSelect from "@/components/shop/business/select";
import treeSelect from "@/components/common/treeSelect";
import goodsDialog from "@/components/goods/info/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
    businessSelect,
    treeSelect,
    goodsDialog,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        SectionType: 0,
        SectionName: "",
        PhotoAddress: "",
        LinkAddress: "",
        StoreId: null,
        OrderId: 0,
        GoodsTypeId: null,
        GoodsId: null,
        GoodsName: "",
      },

      api: require("@/api/store/section").default,
      api2: require("@/api/goods/type").default,
      isMB: this.$store.state.isMB,
      rules: {
        SectionName: [{ required: true, message: "板块名称不能为空" }],
        PhotoAddress: [{ required: true, message: "图片不能为空" }],

        OrderId: [{ required: true, message: "序号不能为空" }],
      },
      uploadUrl: "/api/Common/UploadPicture",
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      TypePlatforms: [],
      props: {
        value: "RecordId",
        label: "TypeName",
        children: "children",
      },
    };
  },
  watch: {
    //监听
    "data.StoreId": {
      //监听AdType的值，
      handler(val, oldVal) {
        if (val) {
          if (this.data.RecordId > 0) {
          } else {
            this.data.GoodsTypeId = null;
          }
          this.getOption();
        }
      },
    },
  },
  methods: {
    getOption() {
      var param = { State: 1 };
      if (this.loginInfo.UserType == 0) {
        param.StoreId = this.data.StoreId;
      }
      this.api2.list(param).then((res) => {
        if (res.Code == 0) {
          this.TypePlatforms = this.$commonJs.toTreeData(
            res.Data,
            "RecordId",
            "TypeIdParent",
            "children"
          );
          if (this.$refs.treeSelect) {
            this.$refs.treeSelect.setData();
          }
        }
      });
    },
    onGoodsDialog() {
      var param = { SaleState: 1 };
      if (this.loginInfo.UserType == 0) {
        param.StoreId = this.data.StoreId;
      }
      this.$refs.goodsDialog.open().then((that) => {
        that.getData(param);
        that.getTree();
      });
    },
    setGoods(t) {
      console.log(t, "setgoods");
      this.data.GoodsId = t.RecordId;
      this.data.GoodsName = t.GoodsName;
    },
    onTreeSelect(t) {
      if (!t) {
        this.data.GoodsTypeName = "";
        this.data.GoodsTypeId = null;
      } else {
        this.data.GoodsTypeName = t.TypepName;
        this.data.GoodsTypeId = t.RecordId;
      }
    },
    onCreateOpened(row) {
      this.getOption();
      this.api.getMaxOrderId().then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
    },
    onEditOpened(row) {
      this.getOption();
    },
    onBeforeSave() {},
    onClosed() {},
  },
};
</script>